import { MAT_DIALOG_DATA } from '@angular/material';
import { CourseService } from './../../../../services/http/business/course/course.service';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngstack/translate';

@Component({
  selector: 'app-student-transfer-details',
  templateUrl: './student-transfer-details.component.html',
  styleUrls: ['./student-transfer-details.component.css']
})
export class StudentTransferDetailsComponent implements OnInit {

  oldCourseInfo: any = {};
  newCourseInfo: any = {};

  constructor(private courseService: CourseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService) { }

  ngOnInit() {
    this.getCourseInfo();
  }

  getCourseInfo()
  {
    this.courseService.getCourseInfoById({xId: this.data.fromCourseId}).subscribe({
      next: (value: any) => {
        this.oldCourseInfo = value;
      }
    })

    this.courseService.getCourseInfoById({xId: this.data.toCourseId}).subscribe({
      next: (value: any) => {
        this.newCourseInfo = value;
      }
    })
  }
}
